import { InterviewStatus } from './interview-status';

export enum InterviewCancellationFeedback {
  Sick = 'sick',
  NoReason = 'no_reason',
  DirectEmployerCancellation = 'direct_employer_cancellation',
  NoContactWithCem = 'no_contact_with_cem',
  NoTime = 'no_time',
  StepIn = 'step_in',
  DayPlanChange = 'day_plan_change',
  PrivateOffer = 'private_offer',
  NoLongerInterested = 'no_longer_interested',
  TooFar = 'too_far',
  HiredAtPartner = 'hired_at_partner',
  DeadlineCollision = 'deadline_collision',
  Other = 'other',
}

export const INTERVIEW_CANCELLATION_FEEDBACK_TRANSLATIONS = {
  [InterviewCancellationFeedback.Sick]: 'Krank',
  [InterviewCancellationFeedback.NoReason]: 'Kein Grund',
  [InterviewCancellationFeedback.DirectEmployerCancellation]: 'Direkt bei ER abgesagt',
  [InterviewCancellationFeedback.NoContactWithCem]: 'Kein Kontakt zu CEMler',
  [InterviewCancellationFeedback.NoTime]: 'Keine Zeit',
  [InterviewCancellationFeedback.StepIn]: 'Einspringen',
  [InterviewCancellationFeedback.DayPlanChange]: 'DP-Änderung / aktueller AG',
  [InterviewCancellationFeedback.PrivateOffer]: 'Privates Angebot',
  [InterviewCancellationFeedback.NoLongerInterested]: 'Kein Interesse mehr',
  [InterviewCancellationFeedback.TooFar]: 'Entfernung zu weit weg',
  [InterviewCancellationFeedback.HiredAtPartner]: 'Hired bei Partner',
  [InterviewCancellationFeedback.DeadlineCollision]: 'Terminkollision / AGC bestätigt',
  [InterviewCancellationFeedback.Other]: 'Andere',
};

export const INTERVIEW_STATUS_WITH_CANCELLATION_FEEDBACK = [
  InterviewStatus.CancelledByCandidate,
  InterviewStatus.CandidateAbsentWithoutExcuse,
];
